import { TFunction } from 'i18next';

import { AuditEventKind } from './auditData';

type T = TFunction<'intent-conversation-analytics'>;

export const getKindLabel = (t: T, kind: AuditEventKind): string => {
  const labels: Record<AuditEventKind, string> = {
    api: t('conversationAudit.kindApi'),
    error: t('conversationAudit.kindError'),
    intent: t('conversationAudit.kindIntent'),
    retrieval: t('conversationAudit.kindSource'),
    step: t('conversationAudit.kindStep'),
    tool: t('conversationAudit.kindTool'),
  };
  return labels[kind];
};

export const getPayloadAbsenceLabel = (
  t: T,
  absence: 'not_captured' | 'redacted' | 'unavailable',
) => {
  if (absence === 'redacted') {
    return t('conversationAudit.absenceRedacted');
  }
  if (absence === 'unavailable') {
    return t('conversationAudit.absenceUnavailable');
  }
  return t('conversationAudit.absenceNotCaptured');
};
